import chatAPI from '@/api/chatAPI'
import userAPI from '@/api/userAPI'

export default {
    setChatSearchQuery({ commit }, query){
        commit('SET_CHAT_SEARCH_QUERY', query)
    },
    updateAboutChat({ commit, rootState }, value) {
        commit('UPDATE_ABOUT_CHAT', {rootState: rootState, value: value})
    },
    updateStatusChat({ commit, rootState }, value) {
        commit('UPDATE_STATUS_CHAT', {rootState: rootState, value: value})
    },

    // API CALLS
    sendChatMessage({ getters, commit }, payload) {
      return new Promise((resolve, reject) => {
        if(!payload.resend){
          payload.chatData = getters.chatDataOfUser(payload.id)
          commit('SEND_CHAT_MESSAGE', payload)
        } else {
          payload.status = 'sending'
          commit('CHANGE_MESSAGE_STATUS', payload)
        }

        chatAPI.create({user_id: payload.id, 'message': payload.msg.textContent})
          .then((response) => {
            payload.status = 'sent'
            commit('CHANGE_MESSAGE_STATUS', payload)
            resolve(response)
          })
          .catch((error) => {
            payload.status = 'error'
            commit('CHANGE_MESSAGE_STATUS', payload)
            reject(error)
          })
      })
    },

    fetchChatContacts({ commit }) {
      return new Promise((resolve, reject) => {
        chatAPI.getAll()
          .then(({data}) => {
            commit('UPDATE_CHAT_CONTACTS', data.contacts)
            commit('UPDATE_CONTACTS', data.contacts)
            commit('UPDATE_CHATS', data.messages)
            resolve(data)
          })
          .catch((error) => { reject(error) })
      })
    },

    startChat({ state, commit }, userId){
      return new Promise(async (resolve) => {
        let contact = state.chatContacts.find(contact => contact.id === parseInt(userId))
        if(!contact) {
          await userAPI.profile(parseInt(userId)).then(({data}) => {
            const name = `${data.user.first_name} ${data.user.middle_name} ${data.user.last_name}`
            contact = {id: data.user.id, name: name, image: data.user.image}
            commit('INSERT_CHAT_CONTACT', contact)
          })
        }
        resolve(contact)
      })
    },

    // RECEIVE_NEW_MESSAGE
    receiveNewMessage({state, commit}, payload) {
        if(state.chats[payload.id]){
          commit('RECEIVE_NEW_MESSAGE', payload)
        } else {
          userAPI.profile(parseInt(payload.id)).then(({data}) => {
            const name = `${data.user.first_name} ${data.user.middle_name} ${data.user.last_name}`
            const contact = {id: data.user.id, name: name, image: data.user.image}
            commit('INSERT_CHAT_CONTACT', contact)
            commit('RECEIVE_NEW_MESSAGE', payload)
          })
        }
    },

    loadMoreMessages({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
          const chat = state.chats[payload.id]
          chatAPI.loadMoreMessages(payload.id, {params: {limit: state.limit, page: chat.page}})
            .then(({data}) => {
                let loadMore = false
                if(data.messages.length > 0){
                    commit('INSERT_MESSAGES_TO_CHAT', {id: payload.id, msg: data.messages})
                    loadMore = true
                }
                resolve(loadMore)
            }).catch(error => reject(error))
        })
    },

    markSeenAllMessages({ getters, commit }, id) {
      return new Promise((resolve, reject) => {
        chatAPI.markAllSeen(id).then((response) => {
            commit('MARK_SEEN_ALL_MESSAGES', { id: id, isSent: false, chatData: getters.chatDataOfUser(id) })
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
}
